import React from "react";
import * as styles from "./OfferHighlights.module.scss";
import OfferHighlightCard from "./OfferHighlightCard";
import clsx from "clsx";
import { BackgroundColor } from "types/componentBackground";
import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";

export type OfferHighlight = {
  name: string | BlockContentValue;
  description: string | BlockContentValue;
  icon?: string;
  iconUrl?: string;
  tokenValues?: TokenValues;
};

interface OfferHighlightsProps {
  title?: string;
  offers: OfferHighlight[];
  tokenValues?: TokenValues;
  variant?: "large" | "small";
  cardBackgroundColor?: BackgroundColor;
  defaultOfferIconUrl: string | undefined;
}

const OfferHighlights: React.FC<
  React.PropsWithChildren<OfferHighlightsProps>
> = ({
  title,
  offers = [],
  tokenValues = {},
  variant = "large",
  cardBackgroundColor = "neutral05",
  defaultOfferIconUrl
}) => {
  return (
    <section
      className={clsx({
        [styles.variantLarge]: variant == "large",
        [styles.variantSmall]: variant == "small"
      })}
    >
      {title && (
        <header className={styles.header}>
          <h4 className={styles.title}>{title}</h4>
        </header>
      )}
      <div className={styles.offers}>
        {offers.map((offer, index) => {
          const mergedTokenValues = {
            ...tokenValues,
            ...(offer.tokenValues || {})
          };
          return (
            <OfferHighlightCard
              key={index}
              offer={offer}
              tokenValues={mergedTokenValues}
              backgroundColor={cardBackgroundColor}
              defaultOfferIconUrl={defaultOfferIconUrl}
            />
          );
        })}
      </div>
    </section>
  );
};

export default OfferHighlights;
